// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-search-wrapper[data-v-c37703e2] {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0;
  overflow: hidden;
}
.global-search-wrapper .search-wrapper[data-v-c37703e2] {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px 15px 15px 15px;
  border: none;
}
.global-search-wrapper .search-wrapper .search-close[data-v-c37703e2] {
  cursor: pointer;
  text-decoration: none;
  position: absolute;
  transition-property: all;
  transition-duration: .25s;
  font-size: var(--searchCloseFontSize);
  right: var(--searchCloseRight);
}
.global-search-wrapper .search-wrapper .search-close.h[data-v-c37703e2] {
  margin-left: 100%;
  transition-property: all;
  transition-duration: .25s;
  visibility: hidden;
}
.global-search-wrapper .search-wrapper .search.shrink[data-v-c37703e2] {
  width: 75%;
  transition-property: width;
  transition-duration: .25s;
}
.global-search-wrapper .search-body[data-v-c37703e2] {
  position: relative;
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/search/Items.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".global-search-wrapper[data-v-c37703e2] {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  overflow: hidden;\n}\n.global-search-wrapper .search-wrapper[data-v-c37703e2] {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 15px 15px 15px 15px;\n  border: none;\n}\n.global-search-wrapper .search-wrapper .search-close[data-v-c37703e2] {\n  cursor: pointer;\n  text-decoration: none;\n  position: absolute;\n  transition-property: all;\n  transition-duration: .25s;\n  font-size: var(--searchCloseFontSize);\n  right: var(--searchCloseRight);\n}\n.global-search-wrapper .search-wrapper .search-close.h[data-v-c37703e2] {\n  margin-left: 100%;\n  transition-property: all;\n  transition-duration: .25s;\n  visibility: hidden;\n}\n.global-search-wrapper .search-wrapper .search.shrink[data-v-c37703e2] {\n  width: 75%;\n  transition-property: width;\n  transition-duration: .25s;\n}\n.global-search-wrapper .search-body[data-v-c37703e2] {\n  position: relative;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
